export default {"src":"/_next/static/media/PREVIEW_PROJECT.c190e6b6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};